import { useEffect, useRef } from 'react'
import styled from 'styled-components'

const StyledTrustPilot = styled.div`
  color-scheme: ${props => (props.$isDark ? 'dark' : 'light')};
`

const TrustPilot = () => {
  const ref = useRef(null)
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])
  return (
    <StyledTrustPilot
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-AU"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="60ec16cc07a4ad000165182a"
      data-style-height="40px"
      data-style-width="100%"
    >
      <a href="https://www.trustpilot.com/review/example.com" target="_blank" rel="noreferrer">
        Trustpilot
      </a>
    </StyledTrustPilot>
  )
}

export default TrustPilot
